import $ from 'jquery';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { RequestCallModal } from '@bingads-webui-react/request-call-modal';

export const requestCallModalLocalization = {
  RequestCallModal_Continue: _TL_('Continue'),
  RequestCallModal_Cancel: _TL_('Cancel'),
  RequestCallModal_Close: _TL_('Close'),
  RequestCallModal_CallMeBack: _TL_('Call me back'),
  RequestCallModal_ReasonForCall: _TL_('How can we help you?'),
  RequestCallModal_AdvertiserSupport: _TL_('I need help with Microsoft Advertising or have a general question'),
  RequestCallModal_AgencySupport: _TL_('I am an agency managing clients on Microsoft Advertising'),
  RequestCallModal_ComplexSupportScenario: _TL_('I have a question about Microsoft Shopping campaign or conversion tracking'),
  RequestCallModal_OptimizationConsult: _TL_('I want coaching on how to optimize my campaign performance'),
  RequestCallModal_SmartCampaign: _TL_('I need help with Smart campaigns or have a general question'),
  RequestCallModal_DMCSupport: _TL_('I need help with Digital Marketing Center or have a general question'),
  RequestCallModal_UPSupport: _TL_('I need help with Multiplatform campaigns or have a general question'),
  RequestCallModal_SmartPageSupport: _TL_('I need help with Smart Pages or have a general question'),
  RequestCallModal_DialogReadyLabel: _TL_('Call me back dialog is ready'),
};

export const RequestCallSupport = (props) => {
  const {
    i18n,
    permissions,
    currentAccount,
    supportOptions,
    featureName,
    portalClassName,
    flowId,
  } = props;
  const accountNumber = currentAccount && currentAccount.AccountNumber;
  const [open, setOpen] = useState(false);
  const [onCancelCallback, setOnCancelCallback] = useState(null);
  const { RequestCallText } = supportOptions;
  const legacyi18n = useMemo(
    () => buildLegacyI18n(i18n, [requestCallModalLocalization], []),
    [i18n]
  );

  const onClose = useCallback(() => {
    setOpen(false);
    if (onCancelCallback) {
      onCancelCallback();
    }
  }, [onCancelCallback]);

  const isSupported = !isEmpty(RequestCallText);

  useEffect(() => {
    let cancelled = false;
    const handler = (e, data) => {
      setOnCancelCallback(data && data.onCancel);
      /* istanbul ignore next */
      if (!cancelled) {
        setOpen(true);
      }
    };

    $('#requestCallTrigger').on('click', handler);
    return () => {
      cancelled = true;
      $('#requestCallTrigger').off('click', handler);
    };
  }, []);

  if (!isSupported) return (null);

  return (
    <div>
      <div id="requestCallTrigger" />
      <div id="requestCallModalContainer" >
        <RequestCallModal
          {...props}
          isOpen={open}
          onClose={onClose}
          i18n={legacyi18n}
          featureName={featureName}
          context={{ accountNumber, flowId }}
          portalClassName={portalClassName}
          permissions={permissions}
        />
      </div>
    </div>
  );
};

RequestCallSupport.propTypes = {
  supportOptions: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  currentAccount: PropTypes.shape({}),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  featureName: PropTypes.string,
  portalClassName: PropTypes.string,
  flowId: PropTypes.string,
};

RequestCallSupport.defaultProps = {
  currentAccount: {},
  flowId: 'advertiser',
  featureName: undefined,
  portalClassName: undefined,
};
